import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "../SpaceDialogAction";
import { TITLES_OF_DIALOG_CONFIRMATION } from "../utils/constants";

const DialogStudentTakeAttendanceConfirmation = ({
	dialog, selectedStudents,
	takeStudentAttendance
}) => {
	function getTitleOfDialogTakeStudentsAttendanceConfirmation() {
        if (selectedStudents.onlyOneStudentSelected())
            return TITLES_OF_DIALOG_CONFIRMATION.TAKE_STUDENT_ATTENDANCE.ONE_STUDENT;
        if (selectedStudents.allSelected())
            return TITLES_OF_DIALOG_CONFIRMATION.TAKE_STUDENT_ATTENDANCE.ALL_STUDENTS;
        return TITLES_OF_DIALOG_CONFIRMATION.TAKE_STUDENT_ATTENDANCE.SOME_STUDENTS;
    }
	return (
		<SpaceDialogAction
			dialog={dialog}
			title={getTitleOfDialogTakeStudentsAttendanceConfirmation()}
			content="Recuerda que al marcar la asistencia de un alumno, ya no podrás eliminarlo de la reserva.">
			<CustomButton
				variant="secondary"
				width="120px"
				text="No, cancelar"
				onClick={dialog.hide} />
			<CustomButton
				width="120px"
				text="Si, aceptar"
				onClick={takeStudentAttendance} />
		</SpaceDialogAction>
	);
}

export default DialogStudentTakeAttendanceConfirmation;